// extracted by mini-css-extract-plugin
export default {"formWrapper":"formView_formWrapper__fWjCn","formView":"formView_formView__wP16a","pdfFormContent":"formView_pdfFormContent__mwwGx","dataInfo":"formView_dataInfo__jiNNk"};